import { render, staticRenderFns } from "./union-card.vue?vue&type=template&id=d1698eca&scoped=true&lang=pug&"
import script from "./union-card.vue?vue&type=script&lang=js&"
export * from "./union-card.vue?vue&type=script&lang=js&"
import style0 from "./union-card.vue?vue&type=style&index=0&id=d1698eca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1698eca",
  null
  
)

export default component.exports